import AuthCheck from './AuthCheck';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import PasswordChange from './PasswordChange';
import Register from './Register';
import LocalStorageCheck from "./LocalStorageCheck";

export {
    AuthCheck,
    Login,
    PasswordChange,
    Register,
    LocalStorageCheck,
    ForgotPassword
};



// WEBPACK FOOTER //
// src/client/components/common/authentication/index.js